module.exports = __webpack_public_path__ + "static/media/horme.3858dc23.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/horme.png
// module id = 401
// module chunks = 0